//Returns date in "D-M-YYYY" format
const format1 = (date) => {
    if (!date) {
        return "NA"; // Return "NA" if the date is blank or invalid
    }

    const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
    const formattedDate = new Date(date);
    return `${formattedDate.getDate()}-${formattedDate.getMonth() + 1}-${formattedDate.getFullYear()}`;
};

//Returns date in "Tue, May 7, 2024" format
const format2 = (date) => {
    if (!date) {
        return "NA"; // Return "NA" if the date is blank or invalid
    }

    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return `${formattedDate} `;
};

//Returns date in "M/D/YYYY" format
const format3 = (date) => {
    if (!date) {
        return "NA"; // Return "NA" if the date is blank or invalid
    }

    const options = { month: 'numeric', day: 'numeric', year: 'numeric' };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return `${formattedDate}`;
};

//Returns Time in "H:M AMPM" format
const format4 = (date) => {
    if (!date) {
        return "NA"; // Return "NA" if the date is blank or invalid
    }

    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    const time = new Date(date).toLocaleTimeString('en-US', options);
    return time; // Return the formatted time
};

//Returns date in "May 7, 2024" format
const format5 = (date) => {
    if (!date) {
        return "NA"; // Return "NA" if the date is blank or invalid
    }

    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    const formatedDated = new Date(date).toLocaleDateString('en-US', options);
    return `${formatedDated}`
};

//Returns readable date like "Today, Yesterday" or "7th May" if it is in same year
//or returns the date in FORMAT2 format

const format6 = (inputdate) => {
    const date = new Date(inputdate);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const isToday = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
    const isYesterday = date.getDate() === yesterday.getDate() && date.getMonth() === yesterday.getMonth() && date.getFullYear() === yesterday.getFullYear();
    const isPresentYear = date.getFullYear() === today.getFullYear();

    if (isToday) {
        return 'Today';
    } else if (isYesterday) {
        return 'Yesterday';
    } else if (isPresentYear) {
        const day = date.getDate();
        const suffix = (day >= 11 && day <= 13) ? 'th' : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][day % 10];
        return `${day}${suffix} ${date.toLocaleDateString('en-US', { month: 'short' })}`;
    } else {
        return format2(date);
    }
};


export const getDateTimeFormatted = (date, formatType) => {

    switch (formatType) {
        case 'FORMAT1':
            return format1(date);

        case 'FORMAT2':
            return format2(date);

        case 'FORMAT3':
            return format3(date);

        case 'FORMAT4':
            return format4(date);

        case 'FORMAT5':
            return format5(date);

        case 'FORMAT6':
            return format6(date);

        default:
            return date;
    }

};

export const getTimeDifference = (startTime, endTime) => {
    if (!startTime || !endTime) {
        return "Invalid time inputs";
    }

    const start = new Date(startTime);
    const end = new Date(endTime);

    // Check if both times are valid
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
        return "Invalid date format";
    }

    // Get the difference in milliseconds
    const diffInMs = end.getTime() - start.getTime();

    // Convert the difference to minutes, hours, and days
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    // Remaining hours and minutes after removing full days and hours
    const remainingHours = diffInHours % 24;
    const remainingMinutes = diffInMinutes % 60;

    // If more than a day
    if (diffInDays > 0) {
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''}, ${remainingHours} hour${remainingHours !== 1 ? 's' : ''}, ${remainingMinutes} minute${remainingMinutes !== 1 ? 's' : ''}`;
    }

    // If more than an hour
    if (diffInHours > 0) {
        return `${remainingHours}:${remainingMinutes < 10 ? `0${remainingMinutes}` : remainingMinutes} hours`;
    }

    // Less than an hour, just minutes
    return `${remainingMinutes} minute${remainingMinutes !== 1 ? 's' : ''}`;
};